import { render, staticRenderFns } from "./work_item_assignees_with_edit.vue?vue&type=template&id=0afa35f3"
import script from "./work_item_assignees_with_edit.vue?vue&type=script&lang=js"
export * from "./work_item_assignees_with_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports